
    import '/Users/jilin/projects/antd/rc-dialog/docs/demo/bootstrap.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"bootstrap","toc":"menu","filename":"docs/demo/bootstrap.md","lastUpdated":1674027995000,"nav":{"title":"Demo","path":"/demo"}};